export const slbHeader = {
    actions: {
        contactUs: "Contact us",
        register: "Register", 
        login: "Login"
    }    
};